module.exports = __webpack_public_path__ + "img/img-dingzhi-s7-tuya.d4d5eb77.jpg";